import React from 'react';
import { Avatar, Badge } from '@mui/material';
import { getInitialLetters } from '../../helpers/data';
import { getImageUrl } from '../../helpers/media';
import { MemberModel, VendorModel } from '../../config/types';
import { createStyles, DefaultTheme, withStyles } from '@mui/styles';

interface Props {
	user: VendorModel | MemberModel;
	showStatus?: boolean;
	status?: 'online' | 'offline';
	size?: string;
	style?: any;
}

const StyledBadge = withStyles((theme: DefaultTheme) =>
	createStyles({
		badge: {
			boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,

			'.status-online &': {
				backgroundColor: theme.palette.success.main,
				color: theme.palette.success.main,
			},

			'.status-offline &': {
				backgroundColor: theme.palette.error.main,
				color: theme.palette.error.main,
			},
		},
	}),
)(Badge);

export default function AppAvatar({
	user,
	status = 'offline',
	showStatus = false,
	size = 'thumbnail',
	style = {},
}: Props) {
	return showStatus ? (
		<StyledBadge
			className={`status-${status}`}
			overlap="circular"
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'right',
			}}
			variant="dot"
		>
			<Avatar
				style={style}
				alt={`Avatar ${user.firstName} ${user.lastName}`}
				src={user.avatar ? getImageUrl(user.avatar, size) : ''}
			>
				{getInitialLetters(`${user.firstName} ${user.lastName}`)}
			</Avatar>
		</StyledBadge>
	) : (
		<Avatar
			style={style}
			alt={`Avatar ${user.firstName} ${user.lastName}`}
			src={user.avatar ? getImageUrl(user.avatar) : ''}
		>
			{getInitialLetters(`${user.firstName} ${user.lastName}`)}
		</Avatar>
	);
}
